import PropTypes from 'prop-types';

const namevalueShape = PropTypes.shape({
  value: PropTypes.string,
  name: PropTypes.string,
});

export const messageShape = PropTypes.shape({
  value: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.number,
  notes: PropTypes.string,
  createdDate: PropTypes.string,
  fromPersonId: PropTypes.number,
});

const documentShape = PropTypes.shape({
  id: PropTypes.string,
  filename: PropTypes.string,
  type: PropTypes.string,
  uploadDate: PropTypes.string,
});

export default {
  applicationId: PropTypes.string,
  accessToken: PropTypes.string,
  isCallInprogress: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  constants: PropTypes.shape({
    APPRAISAL_METHODOLOGIES: PropTypes.arrayOf(namevalueShape),
    BUSINESS: PropTypes.arrayOf(namevalueShape),
    CLIENT: PropTypes.arrayOf(namevalueShape),
    COMPANY_UPDATE_RESPONSIBILITY: PropTypes.arrayOf(namevalueShape),
    DIVERSE_GROUP: PropTypes.arrayOf(namevalueShape),
    DOCUMENT: PropTypes.arrayOf(namevalueShape),
    ETHNICITY: PropTypes.arrayOf(namevalueShape),
    GENDER: PropTypes.arrayOf(namevalueShape),
    INSURANCE: PropTypes.arrayOf(namevalueShape),
    LICENSE: PropTypes.arrayOf(namevalueShape),
    MONTHLY_ORDERS: PropTypes.arrayOf(namevalueShape),
    NUMBER_OF_CLIENTS: PropTypes.arrayOf(namevalueShape),
    PROPERTY: PropTypes.arrayOf(namevalueShape),
    PROGRAM_SERVICE_GROUPS: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
    })),
    YEARS_APPRAISING: PropTypes.arrayOf(namevalueShape),
    TAX_ID: PropTypes.arrayOf(namevalueShape),
  }),
  currentPage: PropTypes.any,
  userProfile: PropTypes.shape({
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    mobile: PropTypes.string,
    alternatePhone: PropTypes.string,
    alternatePhoneExt: PropTypes.string,
    email: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    ssn: PropTypes.string,
    regionId: PropTypes.number,
    regionName: PropTypes.string,
    isDiversityAffirmed: PropTypes.bool,
    gender: PropTypes.string,
    ethnicity: PropTypes.string,
    diverseGroup: PropTypes.string,
    otherGender: PropTypes.string,
    otherEthnicity: PropTypes.string,
    otherDiverseGroup: PropTypes.string,
  }),
  companyProfile: PropTypes.shape({
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
    phoneNumberExt: PropTypes.string,
    alternatePhoneNumber: PropTypes.string,
    alternatePhoneNumberExt: PropTypes.string,
    faxNumber: PropTypes.string,
    faxExt: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    businessType: PropTypes.string,
    yearFounded: PropTypes.any,
    responsibility: PropTypes.arrayOf(PropTypes.string),
    companyOwner: PropTypes.string,
    keyContact: PropTypes.string,
    email: PropTypes.string,
    paymentEmail: PropTypes.string,
    confirmPaymentEmail: PropTypes.string,
    paymentMethod: PropTypes.string,
    crsId: PropTypes.string,
    isFirmIncorporated: PropTypes.bool,
  }),
  serviceGroupFees: PropTypes.shape({
    feeMap: PropTypes.shape({}),
  }),
  coverageList: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({})),
  })),
  regionCoverage: PropTypes.shape({
    zipCodes: PropTypes.arrayOf(PropTypes.string),
    baseArea: PropTypes.bool,
    extendedArea: PropTypes.bool,
    mlsCoverage: PropTypes.bool,
    additionalAreas: PropTypes.string,
    typicalCompletion: PropTypes.shape({
      sunday: PropTypes.arrayOf(PropTypes.string),
      monday: PropTypes.arrayOf(PropTypes.string),
      tuesday: PropTypes.arrayOf(PropTypes.string),
      wednesday: PropTypes.arrayOf(PropTypes.string),
      thursday: PropTypes.arrayOf(PropTypes.string),
      friday: PropTypes.arrayOf(PropTypes.string),
      saturday: PropTypes.arrayOf(PropTypes.string),
    }),
    yearsAppraising: PropTypes.string,
    monthlyOrders: PropTypes.string,
  }),
  slaTargets: PropTypes.shape({
    regionTatTarget: PropTypes.number,
  }),
  professionalInfo: PropTypes.shape({
    languages: PropTypes.string,
    appraisalMethodologies: PropTypes.arrayOf(PropTypes.string),
    hudFhaCertified: PropTypes.bool,
    typicalProperties: PropTypes.arrayOf(PropTypes.string),
    complexProperties: PropTypes.bool,
    newConstruction: PropTypes.bool,
    defaultAppraisals: PropTypes.bool,
    multiFamilyAppraisals: PropTypes.bool,
    clientMix: PropTypes.arrayOf(PropTypes.string),
    numOfClients: PropTypes.string,
    vaApproved: PropTypes.bool,
    usdaExperience: PropTypes.bool,
    pendingLitigation: PropTypes.bool,
    lenderExcluded: PropTypes.bool,
    disciplinaryAction: PropTypes.bool,
    suspension: PropTypes.bool,
    licenseInGoodStanding: PropTypes.bool,
    licensureRefused: PropTypes.bool,
    yearsAppraising: PropTypes.string,
    monthlyOrders: PropTypes.string,
    initialLicenseDate: PropTypes.string,
  }),
  eo: PropTypes.shape({
    insuranceType: PropTypes.string,
    policyNumber: PropTypes.string,
    nameOfInsured: PropTypes.string,
    carrierName: PropTypes.string,
    nameOfPersonCovered: PropTypes.string,
    expiryDate: PropTypes.string,
    perClaimLimit: PropTypes.number,
    aggregateLimit: PropTypes.number,
    claimFiled: PropTypes.bool,
    fileByWhom: PropTypes.string,
    outcomeDescription: PropTypes.string,
    documentList: PropTypes.arrayOf(documentShape),
    document: documentShape,
  }),
  credentials: PropTypes.shape({
    initialLicenseDate: PropTypes.string,
    documents: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      type: PropTypes.string,
      uploadDate: PropTypes.string,
      licenseInfo: PropTypes.shape({
        type: PropTypes.string,
        state: PropTypes.string,
        licenseNumber: PropTypes.string,
        issuedDate: PropTypes.string,
        expiryDate: PropTypes.string,
        active: PropTypes.bool,
      }),
    })),
  }),
  credentialProgress: PropTypes.shape({
    credentialsStatus: PropTypes.string,
    section: PropTypes.shape({
      hasLicense: PropTypes.bool,
      hasW9: PropTypes.bool,
      hasProfilePhoto: PropTypes.bool,
    }),
  }),
};


export const stepsPropType = PropTypes.shape({
  type: PropTypes.string,
  icon: PropTypes.string,
});

/**
* Enum for PayMethods.
* @readonly
* @enum {{id: number, name: string}}
*/
export const PayMethod = Object.freeze({
  MAIL: { id: 0, name: 'Mail' },
  EFT_ACH: { id: 1, name: 'EFT/ACH' },
  ECHECK: { id: 2, name: 'eCheck' },
});
